/*
 * @Descripttion:
 * @version:
 * @Author: shp
 * @Date: 2021-11-30 11:13:57
 * @LastEditors: shp
 * @LastEditTime: 2021-11-30 15:39:08
 */
var merge = require("webpack-merge");

module.exports = merge(
  {},
  {
    NODE_ENV: '"development"',
    GOODWILL_HOST: "http://crmgoodwilltest.porsche-dealer-platform.com",
  },
  {
    NODE_ENV: '"development"',
    MODIFYPASS_HOST: "http://redemption-gateway.boldseas.com",
  },
  {
    NODE_ENV: '"development"',
    REFERRALPLATFORM_HOST: "https://referral.dev.porsche-preview.cn",
  },
  {
    NODE_ENV: '"development"',
    GIFT_HOST: "https://pdmstest.cloudshuo.com",
  },
  {
    NODE_ENV: '"development"',
    ETMT_HOST: "https://s8.dcpo.porsche.cn",
  },
  {
    NODE_ENV: '"development"',
    PORSCHECLUB_HOST: "https://gate.staging.porsche-preview.cn/cm-community-service",
  },
  {
    NODE_ENV: '"development"',
    CM_PORTAL_HOST: "https://crm-portal.dev.porsche-preview.cn/admin",
  },
  {
    NODE_ENV: '"development"',
    SHOW_NEW_REFERRAL_TEST_ENV: true
  }
);



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 5